import t from"./switch";export{StyledSwitchContainer,StyledSwitchInput,StyledSwitchCircle,StyledSwitch}from"./switch.styles";export default t;